import { render, staticRenderFns } from "./startintervention.vue?vue&type=template&id=2fae5b7b&scoped=true&"
import script from "./startintervention.vue?vue&type=script&lang=js&"
export * from "./startintervention.vue?vue&type=script&lang=js&"
import style0 from "./startintervention.vue?vue&type=style&index=0&id=2fae5b7b&lang=scss&scoped=true&"
import style1 from "./startintervention.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2fae5b7b",
  null
  
)

export default component.exports